export default __webpack_public_path__ + "screens@2x.c770d4a7.png";